import * as React from "react";
import finalTick from "../../assets/icons/finalTick.svg";
import "./EsignSubmit.scss";
import { downloadForm } from "../POA/Poa";
import GlobalStore from "../store/globalStore";
import Button from "../UI/Button/Button";
import DeviceContext from "../Services/identifyDevice";
import { containerUrl, loginUrl } from "../../components/utils/constants";
import { isSafariBrowser } from "../Services/globalService";
import { AGetClientAccountCode } from "../Services/dashboard/eSignApiServices";
import { IListObj } from "../types/genericTypes";
import { useHistory } from "react-router-dom";
const EsignSubmit = () => {
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const history = useHistory();
  const [displayTitleList, setDisplayTitleList] = React.useState<
    Array<{ display: string; value: string }>
  >([]);
  function getStarted() {
    //gtmService({ action: "FINAL_STATUS", label: "Get_Started" });
    if (DeviceContext().isDesktop) {
      window.location.href = loginUrl + "user-guide/web";
    } else {
      if (isSafariBrowser()) {
        window.location.href =
          "https://app.appsflyer.com/id1031657545?pid=newEW";
      } else {
        window.location.href = "https://edel.onelink.me/3126852515/a4df843a";
      }
    }
  }
  React.useEffect(() => {
    if (
      GlobalStore?.applicationID == "" ||
      GlobalStore?.applicationID == null ||
      GlobalStore?.applicationID == undefined
    ) {
      alert(
        "Please restart or check your status to continue with your Account Opening process as current session is expired."
      );
      history.push(containerUrl.registration);
      return;
    } else AGetClientAccountCode(getClientDetails, GlobalStore.applicationID);
  }, []);
  function getClientDetails(res: any) {
    if (!res || res.error) {
    } else {
      const responseObj = JSON.parse(res.data);
      const clientPartialDetails_ao = JSON.parse(
        window.sessionStorage.getItem("clientPartialDetails_ao") || "{}"
      );
      if (responseObj && responseObj.dpid) {
        let holderName =
          responseObj.holderfullname !== null &&
          responseObj.holderfullname !== undefined
            ? responseObj.holderfullname
            : clientPartialDetails_ao.PANName
            ? clientPartialDetails_ao.PANName
            : "";
        let mobile =
          responseObj.mobileno !== undefined && responseObj?.mobileno !== null
            ? responseObj.mobileno
            : clientPartialDetails_ao.mobile
            ? clientPartialDetails_ao.mobile
            : "";
        let email =
          responseObj.emailid !== undefined && responseObj?.emailid !== null
            ? responseObj.emailid
            : clientPartialDetails_ao.emailID
            ? clientPartialDetails_ao.emailID
            : "";
        const displayInfo: Array<any> = [];
        if (
          responseObj?.applicationid !== null &&
          responseObj?.applicationid !== undefined &&
          responseObj?.applicationid !== ""
        ) {
          displayInfo.push({
            display: "Account Code",
            value: responseObj?.applicationid,
          });
        }

        if (
          holderName !== null &&
          holderName !== undefined &&
          holderName !== ""
        ) {
          displayInfo.push({ display: "Form ID", value: holderName });
        }

        if (email !== null && email !== undefined && email !== "") {
          displayInfo.push({ display: "Email ID", value: email });
        }

        if (mobile !== null && mobile !== undefined && mobile !== "") {
          displayInfo.push({
            display: "Mobile Number",
            value: mobile,
          });
        }

        if (
          responseObj?.dpid !== null &&
          responseObj?.dpid !== undefined &&
          responseObj?.dpid !== ""
        ) {
          displayInfo.push({ display: "DP ID", value: responseObj?.dpid });
        }

        // setTime(responseObj.esigncompletedtime);
        setDisplayTitleList(displayInfo);
      } else {
        let holderName = responseObj.holderfullname
          ? responseObj.holderfullname
          : clientPartialDetails_ao.PANName
          ? clientPartialDetails_ao.PANName
          : "";
        let mobile = responseObj.mobileno
          ? responseObj.mobileno
          : clientPartialDetails_ao.mobile
          ? clientPartialDetails_ao.mobile
          : "";
        let email = responseObj.emailid
          ? responseObj.emailid
          : clientPartialDetails_ao.emailID
          ? clientPartialDetails_ao.emailID
          : "";
        const displayInfo: Array<any> = [];
        if (
          responseObj?.applicationid !== null &&
          responseObj?.applicationid !== undefined &&
          responseObj?.applicationid !== ""
        ) {
          displayInfo.push({
            display: "Account Code",
            value: responseObj?.applicationid,
          });
        }

        if (
          holderName !== null &&
          holderName !== undefined &&
          holderName !== ""
        ) {
          displayInfo.push({ display: "Form ID", value: holderName });
        }

        if (email !== null && email !== undefined && email !== "") {
          displayInfo.push({ display: "Email ID", value: email });
        }

        if (mobile !== null && mobile !== undefined && mobile !== "") {
          displayInfo.push({
            display: "Mobile Number",
            value: mobile,
          });
        }

        if (
          responseObj?.dpid !== null &&
          responseObj?.dpid !== undefined &&
          responseObj?.dpid !== ""
        ) {
          displayInfo.push({ display: "DP ID", value: responseObj?.dpid });
        }

        // setTime(responseObj.esigncompletedtime);
        setDisplayTitleList(displayInfo);
      }
    }
  }
  React.useEffect(() => {
    if (displayTitleList.length > 0) {
      window.localStorage.removeItem("clientPartialDetails_ao");
    }
  }, [displayTitleList]);
  return (
    <div className="esignsubmit">
      <div className="final-logo-section">
        <img src={finalTick} alt="" className="pfImg" />
      </div>
      <div className="checkStatusHeading">
        <label>Authenticate & Submit Successful</label>
      </div>
      <div className="checkSubStatusHeading">
        Your account opening formalities have been completed.
      </div>
      <div className="clientStepsInfo">
        {displayTitleList &&
          displayTitleList?.length > 0 &&
          displayTitleList.map((record) => {
            return (
              <div className="div-contents-new">
                <span className="display-content"> {record?.display}</span>
                <span className="value-content">{record?.value}</span>
              </div>
            );
          })}
      </div>
      {/* <div className="downloadLink">
        <label className="downloadLbl">You can download your POA form</label>
        <label
          className="hereLbl"
          onClick={() => {
            //   gtmService({ action: "FINAL_STATUS", label: "Download_form" });
            downloadForm(
              `EsignPoa_${GlobalStore.applicationID}`,
              setIsLoading,
              () => {}
            );
          }}
        >
          here
        </label>
      </div> */}
      <div className="startBtn">
        <Button
          btnName="Get Started"
          isLoading={displayTitleList.length <= 0}
          onClick={() => {
            getStarted();
          }}
        />
      </div>
    </div>
  );
};

export default EsignSubmit;
